import { useMemo } from 'react'
import { useIntl } from 'react-intl'
import { formatMiddleDotSeparator } from 'LuxKit/intl/separators'
import ResponsiveImage from 'components/Common/ResponsiveImage'
import { nonNullable } from 'lib/array/arrayUtils'
import { formatOrderTileDates, formatOrderTileOccupancyLabel } from './orderTileDisplayUtils'
import AddedBookingTile, { AddedBookingTileImageFrame } from './AddedBookingTile'
import { useTripDateFormatters } from './useTripDateFormatters'

interface Props {
  propertyName: string
  checkInDate?: string
  checkOutDate?: string
  occupancy?: App.Occupants
  imageId?: string
}

export default function AddedHotelBookingTile({
  propertyName,
  checkInDate,
  checkOutDate,
  occupancy,
  imageId,
}: Props) {
  const intl = useIntl()
  const formatters = useTripDateFormatters()
  const subtitle = nonNullable([
    formatOrderTileDates(formatters, checkInDate, checkOutDate),
    formatOrderTileOccupancyLabel(intl, occupancy),
  ]).join(formatMiddleDotSeparator(intl))

  const thumbnail = useMemo(() => imageId && (
    <AddedBookingTileImageFrame>
      <ResponsiveImage id={imageId} alt={propertyName} fit="center" objectFit="cover" />
    </AddedBookingTileImageFrame>
  ), [imageId, propertyName])

  return <AddedBookingTile title={propertyName} subtitle={subtitle} thumbnail={thumbnail} />
}
